var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageLiveStream01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Manage Live Stream-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.29,3.57A11.21,11.21,0,0,1,23,9.83a10.82,10.82,0,0,1,.25,2.34,11.24,11.24,0,0,1-4,8.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.53,6.94a6.93,6.93,0,0,1,0,10.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.71,3.57A11.21,11.21,0,0,0,1,9.83a10.82,10.82,0,0,0-.25,2.34,11.24,11.24,0,0,0,4,8.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.47,6.94a6.93,6.93,0,0,0,0,10.48"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12.13,
    cy: 12.16,
    r: 1.37
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageLiveStream01);
export default __webpack_public_path__ + "static/media/Manage_LiveStream_01.0ad9e0c491f2dca22abfc7219373dfc8.svg";
export { ForwardRef as ReactComponent };